import React, { Fragment } from 'react';

import { getStaticImageUrl } from 'client/utils/image-helpers';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';

import './vehicle-card-loading-state.scss';

export function VehicleCardLoadingState() {
  const noVehicleImage = getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN);
  const className = 'mx-0_5 pb-1 bg-gray-extra-light';

  return (
    <Fragment>
      <div className="loading-vehicle-card-photo-wrapper d-flex justify-content-center align-items-center mx-auto w-100 bg-gray-extra-light">
        <div
          title="no vehicle"
          className="no-vehicle-img mx-auto w-100"
          style={{ backgroundImage: `url(${noVehicleImage})`, backgroundSize: 'cover' }}
        />
      </div>
      <div className={`w-50 my-1_5 ${className}`} />
      <div className={`mb-0_5 ${className}`} />
      <div className={`mb-0_5 ${className}`} />
    </Fragment>
  );
}
